if (!customElements.get('product-form')) {
	customElements.define('product-form', class AddToCart extends HTMLElement {
		constructor() {
			super();

			this.form = this.querySelector('form[action$="/cart/add"]');
			this.form.querySelector('[name=id]').disabled = false;
			this.form.addEventListener('submit', this.formSubmit.bind(this)); // submit event

			this.giftCheckbox = this.form.querySelector('#gift-cart-checkbox');
			this.giftPopup = document.getElementById('gift-popup');
			this.giftPopupBg = document.getElementById('gift-popup-bg');
			this.giftSubmit = document.getElementById('gift-popup-submit');
			this.giftMessage = document.getElementById('gift-card-message');

			const closeBtn = document.querySelector('[data-gift-modal-close]');

			// ФІКС: Передаємо true, щоб зняти галочку, якщо користувач закрив попап
			[this.giftPopupBg, closeBtn].forEach(el => {
				el?.addEventListener('click', () => {
					this.closeGiftPopup(true);
				});
			});

			// ФІКС: Вішаємо keydown на сам попап для відстеження Escape та роботи "пастки фокусу"
			this.giftPopup?.addEventListener('keydown', (evt) => {
				if (evt.key === 'Escape' && this.giftPopup.classList.contains('open')) {
					this.closeGiftPopup(true); // Передаємо true для скасування чекбоксу
					return;
				}
				// Викликаємо вашу існуючу функцію trapPopupFocus, якщо вона доступна
				if (typeof trapPopupFocus === 'function') {
					trapPopupFocus(evt, this.giftPopup);
				}
			});

			if (this.giftSubmit && !this.giftSubmit.dataset.bound) {
				this.giftSubmit.addEventListener('click', this.addGiftCard.bind(this));
				this.giftSubmit.dataset.bound = 'true';
			}
		}

		formSubmit(evt) {
			evt.preventDefault();
			if (this.giftCheckbox?.checked) {
				this.openGiftPopup();
				return;
			}
			this.addMainProduct();
		}

		addMainProduct() {
			const config = fetchConfig('javascript');
			config.headers['X-Requested-With'] = 'XMLHttpRequest';
			delete config.headers['Content-Type'];
			const formData = new FormData(this.form);
			config.body = formData;
			fetch(`${routes.cart_add_url}`, config)
				.then((response) => response.json())
				.then((response) => {
					if (response.status) {
						this.errorMessage(response)
						return;
					}
					this.succses()
					this.removeError()
				})
				.catch((error) => {
					console.log(error);
				});
		}

		addGiftCard() {
			const selectedCard = document.querySelector('.gift-card-item.selected');
			const message = this.giftMessage.value.trim().slice(0, 150);

			if (!selectedCard) {
				alert('Please select a gift card');
				return;
			}

			const cardVariantId = selectedCard.dataset.variantId;
			const parentProductHandle = selectedCard.dataset.parentHandle;

			const config = fetchConfig('javascript');
			config.headers['X-Requested-With'] = 'XMLHttpRequest';
			delete config.headers['Content-Type'];

			const formData = new FormData();
			formData.append('id', cardVariantId);
			formData.append('quantity', 1);
			if (message) formData.append('properties[Message]', message);
			formData.append('properties[_is-gift]', 'true');
			formData.append('properties[_parent-handle]', parentProductHandle);
			config.body = formData;

			fetch(`${routes.cart_add_url}`, config)
				.then((response) => response.json())
				.then((response) => {
					if (response.status) {
						console.warn("❌ Gift card add error:", response);
						this.errorMessage(response);
						return;
					}

					this.addMainProduct();
					this.removeError();
					this.closeGiftPopup(false); // Тут false, бо подарунок успішно додано
				})
				.catch((error) => {
					console.log("Gift card fetch error:", error);
				});
		}

		openGiftPopup() {
			if (!this.giftPopup || !this.giftPopupBg) return;

			document.body.classList.add("is-scroll-hidden");
			this.giftPopup.classList.add('open');
			this.giftPopupBg.classList.add('open');

			// ФІКС ДОСТУПНОСТІ: Атрибути для скрінрідерів та блокування фону (iOS)
			this.giftPopup.setAttribute('aria-hidden', 'false');
			const mainContent = document.getElementById("MainContent") || document.querySelector("main");
			const siteHeader = document.querySelector(".header") || document.querySelector("header");
			const siteFooter = document.querySelector("footer");
			if (mainContent) mainContent.setAttribute("inert", "");
			if (siteHeader) siteHeader.setAttribute("inert", "");
			if (siteFooter) siteFooter.setAttribute("inert", "");

			// ФІКС ДОСТУПНОСТІ: Безпечний перехід фокусу без стрибка екрана
			const focusableElements = getFocusableElements(this.giftPopup);
			setTimeout(() => {
				if (focusableElements.length) {
					focusableElements[0].focus({ preventScroll: true });
				} else {
					this.giftPopup.focus({ preventScroll: true });
				}
			}, 50);
		}

		closeGiftPopup(resetCheckbox = false) {
			if (!this.giftPopup || !this.giftPopupBg) return;

			this.giftPopup.classList.remove('open');
			this.giftPopup.setAttribute('aria-hidden', 'true');

			setTimeout(() => {
				this.giftPopupBg.classList.remove('open');
			}, 300);
			document.body.classList.remove("is-scroll-hidden");

			// ФІКС ДОСТУПНОСТІ: Розблоковуємо фон
			const mainContent = document.getElementById("MainContent") || document.querySelector("main");
			const siteHeader = document.querySelector(".header") || document.querySelector("header");
			const siteFooter = document.querySelector("footer");
			if (mainContent) mainContent.removeAttribute("inert");
			if (siteHeader) siteHeader.removeAttribute("inert");
			if (siteFooter) siteFooter.removeAttribute("inert");

			// Скидаємо чекбокс, якщо користувач закрив попап без збереження
			if (resetCheckbox && this.giftCheckbox) {
				this.giftCheckbox.checked = false;
			}

			// ФІКС ДОСТУПНОСТІ: Повертаємо фокус на кнопку "Add to cart" без стрибка екрана
			const addToCartBtn = this.form.querySelector('button[type="submit"], .carousel-card__label');
			if (addToCartBtn) {
				addToCartBtn.focus({ preventScroll: true });
			}
		}

		errorMessage(resp) {
			const cartBox = $('.js-cart-box-section');
			if(cartBox.length > 0){
				cartBox.find('.cart-box__buttons').addClass( 'has-error');
				let errorBlock = $(`<p class=\"product-error cart-box__description-text\" role=\"alert\">${resp.description}</p>`)
				cartBox.append(errorBlock)
			}
		}

		removeError() {
			const cartBox = $('.js-cart-box-section');
			if(cartBox.length > 0){
				cartBox.find('.cart-box__buttons').removeClass( 'has-error');
				cartBox.find('.product-error').remove();
			}
		}

		succses() {
			const productCard =  this.closest('.carousel-card');
			const productForm=  true;
			if(productCard) {
				productCard.classList.add('selected');
				productCard.querySelector('button').disabled = true;
			}
			const add_to_cart_button = this.querySelector('.cart-box__button');
			if(add_to_cart_button){
				add_to_cart_button.classList.add('product-in-cart')
			}
			updateCartPopup(productForm);
			$('.js-header-cart')[0].click()
		}
	});
}